import script from "./EventDetails.vue?vue&type=script&setup=true&lang=js"
export * from "./EventDetails.vue?vue&type=script&setup=true&lang=js"

import "./EventDetails.vue?vue&type=style&index=0&id=1beff3aa&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-1beff3aa"]])

export default __exports__